import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import i18n from 'i18next';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Helper function to get current language
const getCurrentLanguage = () => {
  return i18n.language || 'ar';
};

// Helper function to get auth token
const getAuthToken = () => {
  const adminData = sessionStorage.getItem('adminkhadamat');
  if (adminData) {
    try {
      const parsed = JSON.parse(adminData);
      // البحث عن التوكن في أماكن مختلفة
      if (parsed.data?.token?.access_token) {
        const token = String(parsed.data.token.access_token);
        return token;
      }
      if (parsed.data?.access_token) return parsed.data.access_token;
      if (parsed.data?.token) return parsed.data.token;
      if (parsed.token) return parsed.token;
      if (parsed.result?.token) return parsed.result.token;
      if (parsed.user?.token) return parsed.user.token;
      return null;
    } catch (error) {
    }
  }
  return null;
};

// Fetch pharmacy requests
export const fetchPharmacyRequests = createAsyncThunk(
  'adminPharmacyRequests/fetchPharmacyRequests',
  async ({ page = 1, search = '', status = '' }, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const params = new URLSearchParams();
      if (page) params.append('page', page);
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      const response = await axios.get(`${BASE_URL}/admin/requests?${params}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept-Language': getCurrentLanguage(),
          'lang': getCurrentLanguage(),
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'فشل في جلب طلبات الصيدليات');
    }
  }
);

// Fetch pharmacy request details
export const fetchPharmacyRequestDetails = createAsyncThunk(
  'adminPharmacyRequests/fetchPharmacyRequestDetails',
  async (requestId, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const response = await axios.get(`${BASE_URL}/admin/requests/${requestId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept-Language': 'ar',
          'lang': 'ar',
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'فشل في جلب تفاصيل الطلب');
    }
  }
);

const initialState = {
  requests: [],
  requestDetails: null,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
    next_page: null,
    prev_page: null
  },
  loading: false,
  error: null,
  detailsLoading: false,
  detailsError: null
};

const adminPharmacyRequestsSlice = createSlice({
  name: 'adminPharmacyRequests',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.detailsError = null;
    },
    clearRequestDetails: (state) => {
      state.requestDetails = null;
      state.detailsError = null;
    }
  },
  extraReducers: (builder) => {
    // Fetch pharmacy requests
    builder
      .addCase(fetchPharmacyRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPharmacyRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.requests = action.payload.data.data || [];
        state.pagination = {
          current_page: action.payload.data.current_page || 1,
          last_page: action.payload.data.last_page || 1,
          per_page: action.payload.data.per_page || 10,
          total: action.payload.data.total || 0,
          next_page: action.payload.data.next_page,
          prev_page: action.payload.data.prev_page
        };
      })
      .addCase(fetchPharmacyRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Fetch pharmacy request details
    builder
      .addCase(fetchPharmacyRequestDetails.pending, (state) => {
        state.detailsLoading = true;
        state.detailsError = null;
      })
      .addCase(fetchPharmacyRequestDetails.fulfilled, (state, action) => {
        state.detailsLoading = false;
        state.requestDetails = action.payload.data;
      })
      .addCase(fetchPharmacyRequestDetails.rejected, (state, action) => {
        state.detailsLoading = false;
        state.detailsError = action.payload;
      });
  }
});

export const { clearError, clearRequestDetails } = adminPharmacyRequestsSlice.actions;
export default adminPharmacyRequestsSlice.reducer;
